<template>
  <div class="xin">
    <div class="switch">
      <el-tabs v-show="user_list" @tab-click="edit_list">
        <!-- 别名列表 -->

        <el-tab-pane label="别名列表">
          <span slot="label">
            {{ $t("logs.agent30") }}
          </span>
          <div class="switch1">
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
                v-loading="loading"
                :cell-class-name="tableCellClassName"
              >
              
                <el-table-column
                  prop="USERNAME"
                  :label="$t('logs.agent32')"
                >
                </el-table-column>

                <el-table-column prop="ACTIVE" :label="$t('logs.agent33')">
                </el-table-column>
                <el-table-column prop="ACTIVE" :label="$t('logs.notice4')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="200"
                >
                  <template slot-scope="scope">
                    <!-- 编辑审核流程

                    <el-button
                      @click="bianji1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("logs.ldap21") }}</el-button
                    >-->
                    <!-- 删除-->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      class="iddefault"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                  <!-- 快编辑审核策略-->
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

        <!-- 添加别名 -->

        <el-tab-pane label="添加别名">
          <span slot="label">
            {{ $t("logs.agent31") }}
          </span>
          <div class="switch1">
            <div class="lie">
              <table>
                <tbody>
                  <tr>
                    <td>{{ $t("logs.agent31") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-input
                        v-model="alias"
                        placeholder
                        clearable
                      ></el-input>

                      <el-alert
                        :title="this.add_show_hint1"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("logs.agent33") }}:</td>
                    <td
                     style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-input v-model="goto" placeholder clearable></el-input>

                      <el-alert
                        :title="this.add_show_hint2"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>
                 <!--   <tr>
                    <td>{{ $t("logs.Policy_list9") }}:</td>
                    <td style="display:flex;flex-direction:row;">
                      <el-checkbox
                        v-model="alias_active"
                        style="height:34px"
                      ></el-checkbox>
                    </td>
                  </tr>-->
                  <tr>
                    <td></td>
                    <td style="display:flex;flex-direction:row">
                      <el-button type="primary" @click="save_user">{{
                        $t("logs.save_a")
                      }}</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-tabs v-show="edit_user" class="edit_tab">
        <!--编辑邮件列表 -->
        <el-tab-pane label="">
          <span slot="label">
            {{ $t("logs.alias_list5") }}
          </span>
          <div class="switch1">
            <div class="lie">
              <table>
                <tbody>
                  <tr>
                    <td>{{ $t("logs.alias_list2") }}:</td>
                    <td
                     style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <span style="text-align:left;color:#0e2c5e;line-height:32px;margin-right:20px">{{this.alias_user}}</span>

                      <el-alert
                        :title="this.add_show_hint1"
                        type="warning"
                        show-icon
                        :closable="false"
                       style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("logs.alias_list3") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:centers"
                    >
                      <el-input v-model="goto" placeholder clearable></el-input>

                      <el-alert
                        :title="this.add_show_hint2"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("logs.Policy_list9") }}:</td>
                    <td style="display:flex;flex-direction:row;">
                      <el-checkbox
                        v-model="alias_active"
                        style="height:34px"
                      ></el-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td style="display:flex;flex-direction:row">
                      <el-button type="primary" @click="save_user">{{
                        $t("logs.save_a")
                      }}</el-button>
                         <el-button type="danger" @click="off_user">{{
                        $t("logs.save_b")
                      }}</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 查询框 -->

    <!--  底部 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      alias_active: true,
      alias: "",
      goto: "",
      tanchu: false,
      edit_user: false,
      user_list: true,
      xian: false,
      add_show_hint2:'',
      add_show_hint1:'',
      fileList1: [],
      alias_user:'1',
      loading: false,
      multipleSelection:[],
    };
  },
  mounted() {
    this.getFileList1();
  },
  methods: {
    // 判断状态变色
    tableCellClassName({ row }) {
      // console.log(row);

      if (row.ISDEFAULT == "是") {
        return "sent1";
      }
      return "";
    },
    edit_list(a) {
      // console.log(a.index)
      if (a.index == 1) {
        this.admin = "";
      }
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 数据统计加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "list_admin",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList1();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList1 = res.data.ret.datalist;
            this.ADD_ON = res.data.ret.ADD_ON;
            this.pwd_hint = res.data.ret.pwd_hint;
            this.multi_address_hint = res.data.ret.multi_address_hint;
            // console.log(this.ISSUPER)
          }
        });
    },
    // 编辑管理员保存
    save_user() {
      // this.user_list = false
      // this.edit_user = true
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_admin",
        sid: sid,

        allow_ip: this.allow_ip,
        passwd2: this.passwd2,
        passwd1: this.passwd1,
        relation_email: this.relation_email,
        newadd: 1,
        admin: this.admin,
      });
      this.$axios
        .post(
          "/api/adm/cgi/admin.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList1();
            this.passwd2 = "";
            this.passwd1 = "";
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 新增管理员保存
    tanSend_user_list() {
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_admin",
        sid: sid,

        relation_email: this.relation_email,
        passwd1: this.passwd1,
        passwd2: this.passwd2,
        allow_ip: this.allow_ip,
        admin: this.admin,
        newadd: 0,

        // data_loadok: this.data_loadok_smtp
      });
      this.$axios
        .post(
          "/api/adm/cgi/admin.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.user_list = true;
            this.edit_user = false;
            this.loading = false;
            // this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            //   this.$router.push({
            //     name: "login",
            // });
          }
        });
    },
    // 编辑更改密码1
    bianji1(index, scope) {
      // console.log(index, scope);
      // this.admin = scope.USERNAME
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let admin = scope.USERNAME;
      let salt_minion_ip = this.salt_minion_ip1;

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "edit_admin",
            sid: sid,
            admin: admin,
            salt_minion_ip: salt_minion_ip,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            (this.passwd1 = ""), (this.passwd2 = ""), (this.edit_user = true);
            this.user_list = false;
            this.loading = false;
            this.admin = res.data.ret.ADMIN;
            this.allow_ip = res.data.ret.ALLOW_IP;
            this.relation_email = res.data.ret.RELATION_EMAIL;
            // this.getFileList();
          }
        });
    },
    // 删除1
    handleClick1(index, scope) {
      // console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let abuse_email = scope.ABUSE_EMAIL;
          let salt_minion_ip = this.salt_minion_ip1;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                __mode: "del_abuse_email",
                sid: sid,
                abuse_email: abuse_email,
                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList1();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
      this.tanchu1 = false;
    },
    tan4: function() {
      this.tanchu = true;
      //   this.tanchu1 = false;
    },
    tanOff: function() {
      this.tanchu = false;
      //   this.tanchu1 = false;
    },
    off_user: function() {
      this.user_list = true;
      this.edit_user = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .table .el-table {
  height: calc(100vh - 180px);
}
/deep/ .has-gutter th {
  text-align: left;
}
/deep/ .has-gutter th:nth-child(2) {
  text-align: left;
}
// 表格居中位置
/deep/ .el-table__row td {
  text-align: left;
}
/deep/ .el-table__row td:nth-child(2) {
  text-align: left;
}
.main-find {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border: 2px solid #d2d7e6;
  background: #ffffff;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  /deep/ .el-input--suffix {
    width: 150px;
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    margin-left: 30px;
  }
}

/deep/ .sent1 .iddefault {
  // color: #f00 !important;
  display: none;
}

/deep/ .el-input__suffix {
  right: 14px;
}
.pass_word {
  flex: 1;
}
/deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 44px;
}
.el-checkbox {
  display: flex;
  align-items: center;
}
.el-radio {
  color: #0e2c5e;
}
/deep/ .edit_tab .el-tabs__nav {
    padding-left: 20px;
}
</style>
